import {PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";

/**
 * Uygulama açılışında player hangi duruma alınmalı.
 *
 * Bu uygulama BOTTUR: görev kuyruğunun sahibi sunucudur ve bot yalnız Electron
 * açıkken koşuyor. Kullanıcı otomatik görev işlemeyi Ayarlar'dan AÇIK bıraktıysa
 * açılışta beklemeye (oto) geçilir; aksi halde 'dur' ile başlanır.
 *
 * Tercih varsayılanı KAPALIDIR (`otomatikIslemeTercihi.ts`): otomatik sorgular
 * UYAP kısıtlaması yüzünden kapalı olduğundan bot canlıdaki gibi 'dur' başlar.
 *
 * Eskiden `App.vue` açılışta KOŞULSUZ `emit('player', dur)` yapıyordu; tercih
 * açık olsa bile bot her açılışta duruyor ve elle "Başlat" gerekiyordu.
 *
 * UYAP engeli (DEV-3572, K4): pencere YENİLEMEDE sessionStorage'da engel kaydı varsa kilit sürer ve açılış
 * kararı HER ZAMAN 'dur'dur (otomatik işleme açık olsa da); bot yalnız kullanıcı eylemiyle (onaylı Başlat ya da
 * "Yeniden denemeye izin ver") başlar. İmzacı kapatılıp açılınca kayıt yoktur: açılış kararı bugünkü gibidir.
 *
 * Saf tutuldu ki bileşen mount etmeden test edilebilsin — repodaki tüm spec'ler
 * bu deseni kullanıyor (mount/shallowMount yok).
 */
export function acilisPlayerDurumu(autoPlay: boolean, engelKaydiVar = false): PlayerDurum {
    if (engelKaydiVar === true) {
        return PlayerDurum.dur;
    }
    return autoPlay === true ? PlayerDurum.oto : PlayerDurum.dur;
}
